import type {
	OriginalItemTypes,
	RenderableItemTypes,
} from "@memorang/types/src/session/new-session";
import { helpDialog } from "./dialog-configs";

const variatTitleMap = {
	MCQ: "Multiple-Choice Question",
	SATA: "Multiple-Response Question",
	CST: "CST",
	writing: "Writing Prompt",
	listening: "Listening Prompt",
	speaking: "Speaking Prompt",
	readingprose: "Reading Prose",
	readingdocuments: "Reading Chart",
	hotspot: "Hotspots",
	quantitative: "Quantitative",
	emailwriting: "email",
	essayGrading: "Essay Grading",
	audioResponse: "Audio Response",
	sequence: "Sequence",
	textAnswer: "Text Answer",
	audioAnswer: "Audio Answer",
	markingAnswer: "Marking Answer",
	vocabulary: "Vocabulary",
	reading: "Reading",
	WRITING: "Writing",
};

export const sessionMaxWidth = {
	summative: 960,
	formative: 840,
	split: 1300,
};

// Horizontal space the split-layout divider occupies between the two columns
// (1px line + 16px margin on each side).
export const SPLIT_DIVIDER_WIDTH = 33;

const AI_SUBMITTABLE_VARIANTS = [
	"INTEGRATED_WRITING_RESPONSE",
	"INTEGRATED_WRITING_STIMULUS",
	"ACADEMIC_DISCUSSION_RESPONSE",
	"AUDIO_INPUT",
	"WRITING_INPUT",
	"MARKING_ANSWER",
	"AUDIO_INPUT_EMOTION",
	"INTERACTIVE_VIDEO",
	"WORKFLOW_GRAPH",
];

export const MAPPED_ITEM_TYPES: Record<OriginalItemTypes, RenderableItemTypes> =
	{
		MCSS: "MCQ",
		MCSSH: "MCQ",
		MCMS: "SATA",
		MCMSH: "SATA",
		INSERT_TEXT: "INSERT_TEXT",
		MATCH_MS: "SATA",
		MCSSM: "MCQ",
		MCMSM: "SATA",
		MCGS: "SATA",
		MCOS: "SEQUENCE",
		AUDIO_INPUT: "AUDIO_INPUT",
		ACADEMIC_DISCUSSION_RESPONSE: "WRITING_INPUT",
		INTEGRATED_WRITING_RESPONSE: "WRITING_INPUT",
		INTEGRATED_WRITING_STIMULUS: "WRITING_INPUT",
		LISTENING_REPLAY: "MCQ",
		FILL_IN_THE_BLANK: "FILL_IN_THE_BLANK",
		MARKING_ANSWER: "MARKING_ANSWER",
		AUDIO_INPUT_EMOTION: "AUDIO_INPUT_EMOTION",
		INTERACTIVE_VIDEO: "INTERACTIVE_VIDEO",
		WORKFLOW_GRAPH: "WORKFLOW_GRAPH",
		SCENARIO_INTRO: "SCENARIO",
		SLIDER_CHOICE: "SLIDER_CHOICE",
		FLASHCARD_DECK: "FLASHCARD",
		BINARY_CHOICE: "BINARY_CHOICE",
		EXPLORE_ACCORDION: "EXPLORE_ACCORDION",
	};

export const NO_RESPONSE_RENDERABLE_TYPES: RenderableItemTypes[] = [
	"SCENARIO",
	"FLASHCARD",
];

const stimulusIconMap = {
	READING: "book-open-page-variant-outline" as const,
	WRITING: "file-document-edit-outline" as const,
	LISTENING: "ear-hearing" as const,
	SPEAKING: "microphone-outline" as const,
	VIDEO: "video-outline" as const,
};

export { variatTitleMap, helpDialog, AI_SUBMITTABLE_VARIANTS, stimulusIconMap };
